// extracted by mini-css-extract-plugin
module.exports = {"graph":"UserStatsGraphs_graph__3mxGq","graphItem":"UserStatsGraphs_graphItem__3583e","total":"UserStatsGraphs_total__3oQQ4"};